import { ucfirst } from '@/helpers';

export const getters = (breakpoints) => {
  const functions = {};

  function smallerThan(breakpoint) {
    return {
      get() {
        return this.screenSizeWidth < breakpoint;
      },
      set() {},
    };
  };

  function greaterThan(breakpoint) {
    return {
      get() {
        return this.screenSizeWidth > breakpoint;
      },
      set() {},
    };
  };

  for (const breakpoint in breakpoints) {
    functions[`screenSizeSmallerThan${ucfirst(breakpoint)}`] = smallerThan(breakpoints[breakpoint]);
    functions[`screenSizeGreaterThan${ucfirst(breakpoint)}`] = greaterThan(breakpoints[breakpoint]);
  };

  return functions;
};
